// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function ProfileApiPage(Props) {
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Ключи API"
      });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                          children: "Personal"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  className: "w-3 h-3 rounded-full bg-success"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium",
                                                  children: "Активный"
                                                })
                                          ],
                                          className: "flex gap-2 items-center"
                                        })
                                  ],
                                  className: "hover:bg-gray-pale px-10 py-3"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                  children: "zxz"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          className: "w-3 h-3 rounded-full bg-alert"
                                                        }),
                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          className: "text-gray-medium",
                                                          children: "Заблокирован"
                                                        })
                                                  ],
                                                  className: "flex gap-2 items-center"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/delete-red-20.svg")
                                        })
                                  ],
                                  className: "hover:bg-gray-pale px-10 py-3 flex justify-between items-center"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                          children: "legacy-test"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  className: "w-3 h-3 rounded-full bg-success"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium",
                                                  children: "Активный"
                                                })
                                          ],
                                          className: "flex gap-2 items-center"
                                        })
                                  ],
                                  className: "hover:bg-gray-pale px-10 py-3"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                          children: "test"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  className: "w-3 h-3 rounded-full bg-gray-medium"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium",
                                                  children: "Истек"
                                                })
                                          ],
                                          className: "flex gap-2 items-center"
                                        })
                                  ],
                                  className: "hover:bg-gray-pale px-10 py-3"
                                }),
                            JsxRuntime.jsx("hr", {
                                  className: "mt-6"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("img", {
                                          className: "w-6 h-6",
                                          src: StaticAsset.src("/static/icons/plus-24.svg")
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                          children: "Добавить ключ"
                                        })
                                  ],
                                  className: "flex gap-3 mt-6 px-10"
                                })
                          ],
                          className: "bg-white w-140.5 py-6 mt-6 rounded shadow-card"
                        }),
                    className: "w-full flex flex-col items-center"
                  }),
              className: "bg-gray-pale"
            });
}

const make = ProfileApiPage;

export {
  make ,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
